import a from "./_has.js";
function r(r, t) {
  var e = function e(c) {
    var i = e.cache,
      n = "" + (t ? t.apply(this, arguments) : c);
    return a(i, n) || (i[n] = r.apply(this, arguments)), i[n];
  };
  return e.cache = {}, e;
}
export { r as default };